// src/components/AlbumPageTemplates/FullBleed.jsx
// REPLACE the entire file with this code

import React from 'react';
import styled from 'styled-components';
import PrintSafeImage from '../PrintSafeImage'; // <-- ADDED

// This styled-component is now just a fallback container
const PhotoContainer = styled.div`
  width: 100%;
  height: 100%;
  display: block;
  background-color: #e0e0e0;
  position: relative; /* <-- ADD THIS */
  overflow: hidden; /* <-- AND THIS */
`;

export default function FullBleed({ items = [], isPrinting }) { // <-- ADDED isPrinting
  const item = items[0];
  const position = item?.position || { x: 50, y: 50, scale: 100 };
  
  // This object combines the original styled-component's CSS
  // with the inline styles for the component.
  const fullPhotoStyle = isPrinting ? {
  // PDF-safe styles
  position: 'absolute',
  width: '100%',
  height: 'auto',
  minWidth: '100%',
  minHeight: '100%',
  top: '50%',
  left: '50%',
  transform: `translate(-50%, -50%) scale(${position.scale / 100}) translateX(${position.x - 50}%) translateY(${position.y - 50}%)`,
} : {
  // LIVE PREVIEW styles (reverted to object-fit)
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  objectPosition: `${position.x}% ${position.y}%`,
  transform: `scale(${position.scale / 100})`,
  transformOrigin: `${position.x}% ${position.y}%`,
};

  return (
    <PhotoContainer>
      {item?.url && (
        <PrintSafeImage // <-- REPLACED <Photo>
          src={item.url} 
          alt="" 
          style={fullPhotoStyle}
          position={position}
          isPrinting={isPrinting}
        />
      )}
    </PhotoContainer>
  );
}